import script from "./audit-dialog.vue?vue&type=script&lang=ts&setup=true&name=AuditDialog"
export * from "./audit-dialog.vue?vue&type=script&lang=ts&setup=true&name=AuditDialog"

const __exports__ = script;

export default __exports__